import { Link, useParams } from "react-router-dom";
// 112 px crops (src/assets/thumbs): the chips show at 36–48 px, and the
// full-size collection photos cost 231 KB at the top of every category page.
import roomLiving from "@/assets/thumbs/room-living.webp";
import roomBedroom from "@/assets/thumbs/room-bedroom.webp";
import roomBathroom from "@/assets/thumbs/room-bathroom.webp";
import roomDining from "@/assets/thumbs/room-dining.webp";
import roomOffice from "@/assets/thumbs/room-office.webp";
import roomOutdoor from "@/assets/thumbs/room-outdoor.webp";
import roomLighting from "@/assets/thumbs/room-lighting.webp";
import roomDecor from "@/assets/thumbs/room-decor.webp";
import roomRugs from "@/assets/thumbs/room-rugs.webp";

const rooms = [
  { label: "Living Room", slug: "living", image: roomLiving },
  { label: "Bedroom", slug: "bed-bath", image: roomBedroom },
  { label: "Bathroom", slug: "bathroom", image: roomBathroom },
  { label: "Dining Room", slug: "dining", image: roomDining },
  { label: "Office", slug: "office", image: roomOffice },
  { label: "Outdoor", slug: "outdoor", image: roomOutdoor },
  { label: "Lighting", slug: "lighting", image: roomLighting },
  { label: "Decor", slug: "decor", image: roomDecor },
  { label: "Rugs", slug: "area-rugs", image: roomRugs },
];

export const CategoryRoomNav = () => {
  const { slug } = useParams<{ slug: string }>();

  // Find which top-level room the current slug belongs to
  const activeRoom = rooms.find((r) => r.slug === slug)?.slug;

  return (
    <div className="border-b border-border">
      <div className="container py-3 md:py-4">
        <div className="flex gap-2 overflow-x-auto scrollbar-hide pb-1">
          {rooms.map((room) => (
            <Link
              key={room.slug}
              to={`/category/${room.slug}`}
              className={`flex items-center gap-2 md:gap-3 px-3 py-1.5 md:px-5 md:py-2.5 border flex-shrink-0 transition-colors ${
                activeRoom === room.slug
                  ? "border-foreground bg-accent"
                  : "border-border hover:border-foreground/40"
              }`}
            >
              {/* Decorative: the label beside it already names the room. */}
              <img
                src={room.image}
                alt=""
                width={36}
                height={36}
                decoding="async"
                className="w-9 h-9 md:w-12 md:h-12 object-cover flex-shrink-0"
              />
              <span className="text-[13px] font-medium whitespace-nowrap">{room.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};
